export default __webpack_public_path__ + "static/media/hero1.92f17d0c.jpg";